import { render, staticRenderFns } from "./UpgradeBanner.vue?vue&type=template&id=a07902d6"
import script from "./UpgradeBanner.vue?vue&type=script&lang=js"
export * from "./UpgradeBanner.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBanner.vue?vue&type=style&index=0&id=a07902d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports